<app-stages [stages]="stages" currentStage="Załączniki">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <div class='row'>
    @if (feeCategory(); as feeCategory) {
      <div class="col-12" style="padding-right: 1.5rem">
        <app-alert [closable]="false">W celu dokonania płatności online zostaniesz przeniesiony do nowej karty. Po
          dokonaniu płatności należy dołączyć potwierdzenie przelewu:
          <a target="_blank"
             title="Link otwierany w nowej zakładce przeglądarki"
             routerLink="/login"
             [queryParams]="{ serviceType: feeCategory, token, callBack: 'platnosci-online' }">
            <strong>
              Przejdź do płatności online
            </strong>
          </a>
        </app-alert>
      </div>
    }
    <div class='col-12'>
      <form novalidate autocomplete='off' [formGroup]='form' (ngSubmit)='submitAndGoNext()'>
        <ol>
          @for (item of attachmentsPositions(); track item.tag) {
            <li>
              <div class='row'>
                <div class='col-md-7'>
                  <p class="mb-2">
                    @if (item.required) {
                      *
                    } {{ item.description }}
                  </p>
                </div>
                <div class='col-md-5'>
                  @if (form.getFormControlByName(item.tag); as control) {
                    <app-file-uploader (pending)="handleUploading($event)" [tagName]='item.tag' [formControl]='control'
                                       [multiple]="item.multiple">
                    </app-file-uploader>
                  }
                </div>
              </div>
            </li>
            @if (!$last) {
              <br>
            }
          }
        </ol>
        <br>
        <div class='application-actions'>
          <button
            type='button'
            class='btn btn-secondary'
            [routerLink]='cancelUrl'>
            <span>
              Wstecz
            </span>
          </button>
          <button
            [disabled]="pending() || uploading()"
            (click)='submitAndGoNext()'
            type='button'
            class='btn btn-primary'>
            @if (uiSettings()?.mobileEmbed) {
              <span>Zatwierdź i przejdź dalej</span>
            } @else {
              <span>Zatwierdź i przejdź do podpisania</span>
            }
          </button>
        </div>
      </form>
    </div>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
